<template>
  <b-card-code title="Demo Version3" />
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { codeDebounce } from './code'

export default {
  components: {
    BCardCode,

  },
  data() {
    return {
      value: '',
      codeDebounce,
    }
  },
}
</script>
